import { Badge } from "@/components/ui/badge";

/** Shows "Sold Out" at 0 and "Only X left" when 3 or fewer remain. Null = unlimited. */
const StockBadge = ({ remaining }: { remaining?: number | null }) => {
  if (remaining === null || remaining === undefined) return null;
  if (remaining <= 0) {
    return (
      <Badge variant="destructive" className="text-xs">
        Sold Out
      </Badge>
    );
  }
  if (remaining <= 3) {
    return (
      <Badge variant="outline" className="text-xs border-warning text-warning">
        Only {remaining} left
      </Badge>
    );
  }
  return null;
};

export default StockBadge;
